export default __webpack_public_path__ + "static/media/blue-header-curve.21635c20.svg";